export const getWidthAndHeightProps = (ref) => {
    if(ref && ref.current) {
        const {width, height} = ref.current.getBoundingClientRect()
        return {
            width: Math.round(width), 
            height:Math.round(height)
        }
    } else if(ref && ref.ref && ref.ref.current) {
        const {width, height} = ref.ref.current.getBoundingClientRect()
        return {
            width: Math.round(width), 
            height:Math.round(height)
        }
    }
    return {}
}